
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import QuemSomos from "../pages/quem-somos/page";
import TeuPedido from "../pages/teupedido/page";
import MoveCourier from "../pages/movecourier/page";
import MovePipe from "../pages/movepipe/page";
import Blog from "../pages/blog/page";
import TermosDeUso from "../pages/termos-de-uso/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/quem-somos",
    element: <QuemSomos />,
  },
  {
    path: "/teupedido",
    element: <TeuPedido />,
  },
  {
    path: "/movecourier",
    element: <MoveCourier />,
  },
  {
    path: "/movepipe",
    element: <MovePipe />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/termos-de-uso",
    element: <TermosDeUso />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
